module.exports = __webpack_public_path__ + "img/2.3976cb0e.png";